import React from 'react';

import { ISvgProps } from '@src/types';

interface IconOptions extends ISvgProps {
  icon: React.FC<ISvgProps>;
  size?: number | string;
  props?: ISvgProps;
}

const DEFAULT_ICON_SIZE = '28px';

export const createIcon = ({ icon, size = DEFAULT_ICON_SIZE, ...props }: IconOptions) => {
  return React.createElement(icon, {
    width: size,
    height: size,
    ...props,
  });
};
